import React from 'react';
interface ImageBackdropProps {
  src: string;
  className?: string;
  /** Never above opacity-10 — the ceiling that keeps type above WCAG AA. */
  opacityClass?: string;
  blurClass?: string;
  overlayClass?: string;
}

/**
 * An image sitting behind text.
 *
 * Renders at 10% opacity or less under a white wash so any type above it stays
 * above WCAG AA. Decorative by definition, so it carries empty alt and is hidden
 * from assistive technology — the text on top is the content.
 */
export function ImageBackdrop({
  src,
  className = '',
  opacityClass = 'opacity-10',
  blurClass = '',
  overlayClass = 'bg-white/70'
}: ImageBackdropProps) {
  return <div aria-hidden="true" className={`pointer-events-none absolute inset-0 ${className}`} data-id="element-653" data-mp="29rmugpomt47z">
      <img src={src} alt="" loading="lazy" decoding="async" className={`h-full w-full scale-110 object-cover ${opacityClass} ${blurClass}`} data-id="element-654" data-mp="2dt83u11yj0df" />
      <div className={`absolute inset-0 ${overlayClass}`} data-id="element-655" data-mp="36cwx9d6l4nsj" />
    </div>;
}